module.exports = __webpack_public_path__ + "img/bc928ef6023c323e327f3e20ecd3a56c.png";